<template>
  <div>
    <div class="row">
      <button
        class="px-4 py-2 border border-red bg-red text-white"
        @click="duplicate"
      >
        Duplicate
      </button>
      <button
        class="px-4 py-2 border border-green bg-green text-white ml-4"
        @click="saveData"
      >
        Save Data
      </button>
      <button
        class="px-4 py-2 border border-green bg-green text-white ml-4"
        @click="showPoints = !showPoints"
      >
        {{ showPoints ? "Hide Points" : "Show Points" }}
      </button>

      <div class="tree-table columns mb-8">
        <div class="row">
          <div class="small-4 columns"><h4>Course Name</h4></div>
          <div class="small-8 columns">
            <input v-model="courseName" type="text" />
          </div>
        </div>
        <div class="row">
          <div class="small-4 columns"><h4>Base Price</h4></div>
          <div class="small-8 columns">
            <input v-model="price" type="text" />
          </div>
        </div>
        <div class="row" style="margin-bottom:40px;">
          <div class="small-4 columns">
            <div>is Preassessment Required</div>
          </div>
          <div class="small-8 columns">
            <input v-model="preassessmentRequired" type="checkbox" />
          </div>
        </div>
        <details
          open="true"
          title="Toggle Phase Creator/Editor"
          class="cursor-pointer"
        >
          <summary>Phase Creator/Editor</summary>
          <div class="phases-container relative cursor-auto">
            <div class="phase-wrapper relative">
              <div>
                <div class="relative">
                  <label
                    class="text-sm"
                    style="position: absolute; top: -20px; left: 0;"
                    >Select A Phase</label
                  >
                  <VueSelect
                    class="mb-8"
                    placeholder="Select a Phase"
                    :options="phaseOptions"
                    label="name"
                    :reduce="option => option.name"
                    @input="selectAPhase"
                  />
                </div>
                <div class="relative mb-2">
                  <label
                    class="text-sm"
                    style="position: absolute; top: -20px; left: 0;"
                    >Phase Name</label
                  >
                  <input
                    v-model.trim="phaseDetails.name"
                    v-validate="'required'"
                    type="text"
                    name="phase name"
                    placeholder="Phase Name"
                  />
                  <small class="err-msg text-red block mt-2">
                    {{ veeValidateErrors.first("phase name") }}
                  </small>
                </div>
              </div>

              <div class="relative mb-2">
                <label class="text-sm"
                  >Phase Position (Decides the position)</label
                >
                <input
                  v-model.trim="phaseDetails.index"
                  v-validate="'required|numeric'"
                  type="number"
                  name="phase index"
                  placeholder="Phase Index"
                />
                <small class="err-msg text-red block mt-2">
                  {{ veeValidateErrors.first("phase index") }}
                </small>
              </div>
              <div class="relative mt-4 flex flex-col">
                <label class="text-sm">Description</label>
                <textarea
                  v-model.trim="phaseDetails.description"
                  v-validate="'required|max:255'"
                  class="mb-3 rounded pl-2 pt-2 mt-2  w-full"
                  type="text"
                  placeholder="Description"
                  name="phase description"
                />
                <small class="err-msg text-red block mt-2">
                  {{ veeValidateErrors.first("phase description") }}
                </small>
              </div>
            </div>

            <div class="flex justify-between items-end">
              <button
                class=" ml-auto bg-green-light text-white p-1"
                style="height: 30px;"
                @click="hamdlePhaseCreation"
              >
                {{ phaseDetails.id ? "Save" : "Create" }}
              </button>
            </div>
            <div class="absolute" style=" top: 0;right: -300px;">
              <div class="pt-3 mb-2">Phases in this Course</div>
              <ol>
                <li v-for="item in getCoursePhases" :key="item.id">
                  {{ item.name }}
                </li>
              </ol>
            </div>
          </div>
        </details>

        <div
          v-for="(module, i) in megaJSON.modules"
          :key="i"
          :draggable="moduleDragEnable"
          class="tree-module-container relative active:bg-grey"
          :class="
            droppedItemId === module.id
              ? 'animate-drop'
              : draggedItemObject.id === module.id
              ? 'dragged-item'
              : ''
          "
          @dragstart.stop="handleDragStart(module.id, 'module')"
          @dragover.stop.prevent="handleDragOver(module.id, 'module')"
        >
          <DropZone
            :currentItemId="module.id"
            :draggedOverItemId="draggedOverItemId"
            :droppedItemId="droppedItemId"
            @dragover.stop.prevent.native="handleDragOver(module.id, 'module')"
            @drop.stop.native="handleDrop(module.id, 'module', module.id)"
          />
          <div class="relative">
            <span @click="toggleModuleExpansion(module.id)">
              <i
                v-if="isModuleExpanded(module.id)"
                class="material-icons tree-icon"
                >keyboard_arrow_down</i
              >
              <i
                v-if="!isModuleExpanded(module.id)"
                class="material-icons tree-icon"
                >keyboard_arrow_right</i
              >
            </span>
            <span> {{ i + 1 }} . {{ module.name }}</span>
            <!---->
            <i v-if="module.is_bonus" class="material-icons bonus-tree-icon"
              >grade <span class="hover-tree-info">BONUS</span>
            </i>
            <i
              v-if="module.is_required"
              class="material-icons required-tree-icon"
              >playlist_add_check <span class="hover-tree-info">REQUIRED</span>
            </i>
            <!---->
            <!---->
            <div class="btns-container items-center">
              <span class="arrows-container">
                <span>
                  <i
                    class="material-icons arrow-icon-ordering"
                    title="Move above"
                    @click="shuffleUpModule(module)"
                    >arrow_upward</i
                  >
                </span>
                <span>
                  <i
                    class="material-icons arrow-icon-ordering"
                    title="Move below"
                    @click="shuffleDownModule(module)"
                    >arrow_downward</i
                  >
                </span>
              </span>
              <span
                title="Edit"
                class="edit-button-tree mr-2"
                @click="editModule(module)"
                >edit</span
              >
            </div>
            <!---->
            <div class="element-highlight-container">
              <span v-if="module.is_payment_locked">Payment Locked, </span>
              <span>{{ getRequiredAndBonusTopics(module) }}</span>
              <span v-if="module.is_dependent_ids.length > 0"
                >, is dependent on : {{ getIsDependentModules(module) }}</span
              >,
              <span v-if="module.phase_id">{{
                getModulePhase(module.phase_id)
              }}</span>
              <span v-if="showPoints" class="block">{{
                getPointsOfModule(module.topics)
              }}</span>
            </div>
          </div>
          <!---->
          <div
            v-for="(topic, j) in module.topics"
            :key="j"
            :draggable="topicDragEnable"
            class="tree-topic-container relative"
            :class="
              droppedItemId === topic.id
                ? 'animate-drop'
                : draggedItemObject.id === topic.id
                ? 'dragged-item'
                : ''
            "
            @dragstart.stop="handleDragStart(topic.id, 'topic', module.id)"
            @dragover.stop.prevent="handleDragOver(topic.id, 'topic')"
          >
            <DropZone
              v-if="isModuleExpanded(module.id)"
              :currentItemId="topic.id"
              :draggedOverItemId="draggedOverItemId"
              :droppedItemId="droppedItemId"
              @dragover.stop.prevent.native="handleDragOver(topic.id, 'module')"
              @drop.stop.native="
                handleDrop(topic.id, 'topic', module.id, topic.id)
              "
            />
            <div v-if="isModuleExpanded(module.id)">
              <div>
                <span @click="toggleTopicExpansion(topic.id)">
                  <i
                    v-if="isTopicExpanded(topic.id)"
                    class="material-icons tree-icon"
                    >keyboard_arrow_down</i
                  >
                  <i
                    v-if="!isTopicExpanded(topic.id)"
                    class="material-icons tree-icon"
                    >keyboard_arrow_right</i
                  >
                </span>
                <span>{{ j + 1 }} . {{ topic.name }}</span>

                <!---->
                <i v-if="topic.is_bonus" class="material-icons bonus-tree-icon"
                  >grade <span class="hover-tree-info">BONUS</span>
                </i>
                <i
                  v-if="topic.is_required"
                  class="material-icons required-tree-icon"
                  >playlist_add_check
                  <span class="hover-tree-info">REQUIRED</span>
                </i>
                <!---->
                <span class="arrows-container btns-container item">
                  <span title="Move above">
                    <i
                      class="material-icons arrow-icon-ordering"
                      @click="shuffleUpTopic(module, topic)"
                      >arrow_upward</i
                    >
                  </span>
                  <span title="Move below">
                    <i
                      class="material-icons arrow-icon-ordering"
                      @click="shuffleDownTopic(module, topic)"
                      >arrow_downward</i
                    >
                  </span>
                  <span
                    class="edit-button-tree mr-2"
                    title="Edit"
                    @click="editTopic(module, topic)"
                    >edit</span
                  >
                </span>
                <span v-if="topic.available_on" class="ml-4">
                  avl. on: {{ getFormatredDateTime(topic.available_on) }}
                </span>
                <div
                  class="element-highlight-container"
                  style="background-color: rgba(0, 0, 255, 0.2);"
                >
                  <span>{{ getRequiredAndBonusQuestions(topic) }}</span>
                  <span v-if="topic.is_dependent_ids.length > 0"
                    >, is dependent on :
                    {{ getIsDependentTopics(module, topic) }}</span
                  >,
                  <span v-if="showPoints" class="block">{{
                    getPointsOfTopic(topic.questions)
                  }}</span>
                </div>
              </div>
              <!---->
              <div
                v-for="(question, k) in topic.questions"
                :key="k"
                :draggable="questionDragEnable"
                class="tree-question-container"
                :class="
                  droppedItemId === question.id
                    ? 'animate-drop'
                    : draggedItemObject.id === question.id
                    ? 'dragged-item'
                    : ''
                "
                @dragstart.stop="
                  handleDragStart(
                    question.id,
                    'question',
                    module.id,
                    topic.id,
                    question.id
                  )
                "
                @dragover.stop.prevent="handleDragOver(question.id, 'question')"
              >
                <DropZone
                  v-if="isTopicExpanded(topic.id)"
                  :currentItemId="question.id"
                  :draggedOverItemId="draggedOverItemId"
                  :droppedItemId="droppedItemId"
                  @dragover.stop.prevent.native="
                    handleDragOver(question.id, 'question')
                  "
                  @drop.stop.native="
                    handleDrop(question.id, 'question', module.id, topic.id)
                  "
                />
                <div v-if="isTopicExpanded(topic.id)" class="relative">
                  <i class="material-icons tree-icon">{{
                    iconToDisplay(question.type)
                  }}</i>
                  <span>{{ k + 1 }} . {{ question.name }}</span>
                  <!---->
                  <i
                    v-if="question.is_bonus"
                    class="material-icons bonus-tree-icon"
                    >grade <span class="hover-tree-info">BONUS</span>
                  </i>
                  <i
                    v-if="question.is_required"
                    class="material-icons required-tree-icon"
                    >playlist_add_check
                    <span class="hover-tree-info">REQUIRED</span>
                  </i>
                  <span class="ml-2 text-sm text-grey-darker"
                    >{{ question.points }} Points</span
                  >
                  <span
                    v-if="question.type === 3"
                    style=" padding-left: 10px; color: #2a5152; font-size: 0.8em;"
                    >Reading Time:
                    {{ (question.reading_time / 60).toFixed(2) }} mins</span
                  >

                  <!---->
                  <span class="flex btns-container item flex items-center">
                    <span>
                      <i
                        class="material-icons arrow-icon-ordering"
                        title="Move above"
                        @click="shuffleUpQuestion(module, topic, question)"
                        >arrow_upward</i
                      >
                    </span>
                    <span>
                      <i
                        class="material-icons arrow-icon-ordering"
                        title="Move below"
                        @click="shuffleDownQuestion(module, topic, question)"
                        >arrow_downward</i
                      >
                    </span>
                    <span
                      class="edit-button-tree mr-2 mr-2"
                      title="Edit"
                      @click="editQuestion(module, topic, question, k)"
                      >edit</span
                    >
                    <span class="float-right">
                      <button
                        class="button text-sm p-1"
                        @click="updateQuestion(question.id, i, j, k)"
                      >
                        Update
                      </button>
                    </span>
                  </span>
                </div>
              </div>
              <button
                v-if="isTopicExpanded(topic.id)"
                class="topic-folder-container-new-post  flex justify-center items-center px-4 rounded-sm py-2 font-normal bg-green-light hover:bg-green text-white"
                style="margin-top:10px;"
                @click="addQuestionToTopic(module, topic)"
              >
                <i class="material-icons mr-2" style="padding-top:0px;"
                  >add_circle</i
                >Add Question
              </button>
            </div>
          </div>
          <div
            v-if="
              module.hasOwnProperty('assignment') && isModuleExpanded(module.id)
            "
            class="assignment-container"
          >
            <div
              style="float:right;color:red;"
              @click="deleteAssignment(module)"
            >
              delete
            </div>
            <h4 style="color:white;">ASSIGNMENT:</h4>
            <div>
              <h3>{{ module.assignment.name }}</h3>
            </div>
            <div>Depends on: {{ getIsDependentAssignmentTopic(module) }}</div>
          </div>
          <button
            v-if="isModuleExpanded(module.id)"
            class="topic-folder-container-new-post flex justify-center items-center px-4 rounded-sm py-2 font-normal bg-green-light hover:bg-green text-white"
            style="margin-top:10px;"
            @click="addTopicToModule(module)"
          >
            <i class="material-icons mr-2">add_circle</i>Add Topic
          </button>
          <button
            v-if="
              isModuleExpanded(module.id) &&
                !module.hasOwnProperty('assignment')
            "
            :topics="currentEditingModule.topics"
            class="topic-folder-container-new-post flex justify-center items-center px-4 rounded-sm py-2 font-normal bg-green-light hover:bg-green text-white"
            style="margin-top:10px;"
            @click="addAssignmentToModule(module)"
          >
            <i class="material-icons mr-2">add_circle</i>Add Assignment
          </button>
        </div>

        <button
          class="module-add-container px-8 py-2 rounded-sm bg-green-light hover:bg-green flex justify-between items-center text-white font-normal"
          @click="openModuleEditor"
        >
          <i class="material-icons text-white mr-4">add_circle</i>Add Module
        </button>
      </div>

      <!---->
      <div class="addition-card">
        <ModuleCreator
          v-if="moduleAdding"
          :modules="megaJSON.modules"
          :phaseOptions="phaseOptions"
          :is_required="isRequiredState"
          :is_bonus="isBonusState"
          @MODULE_CREATED="addModule"
          @CLOSE_MODAL="resetStates"
          @CHECKBOX_STATE_CHANGE="handleCheckboxChange"
        />
        <TopicCreator
          v-if="topicAdding"
          :topics="currentEditingModule.topics"
          :is_required="isRequiredState"
          :is_bonus="isBonusState"
          @TOPIC_CREATED="addTopic"
          @CLOSE_MODAL="resetStates"
          @CHECKBOX_STATE_CHANGE="handleCheckboxChange"
        />
        <QuestionStitcher
          v-if="questionAdding"
          :module-name="currentEditingModule.name"
          :topic-name="currentEditingTopic.name"
          :isRequiredState="isRequiredState"
          :isBonusState="isBonusState"
          :selectedQuestionApi="selectedQuestionApi"
          @QUESTION_ID_ADDED="addQuestion"
          @CLOSE_MODAL="resetStates"
          @CHECKBOX_STATE_CHANGE="handleCheckboxChange"
          @UPDATE_SELECTED_QUESTION_API="handleSelectedQuestionApi"
        />
        <!---->
        <ModuleEditor
          v-if="moduleEditing"
          :module="currentEditingModule"
          :modules="megaJSON.modules"
          :phaseOptions="phaseOptions"
          @MODULE_DELETE="deleteModule"
          @MODULE_UPDATED="updateModule"
          @CLOSE_MODAL="resetStates"
        />
        <TopicEdior
          v-if="topicEditing"
          :topic="currentEditingTopic"
          :topics="currentEditingModule.topics"
          @TOPIC_DELETE="deleteTopic"
          @TOPIC_UPDATED="updateTopic"
          @CLOSE_MODAL="resetStates"
        />
        <QuestionEditor
          v-if="questionEditing"
          :question="currentEditingQuestion"
          @QUESTION_DELETE="deleteQuestion"
          @ELEMENT_UPDATED="resetStates"
          @CLOSE_MODAL="resetStates"
        />
        <AssignmentStitcher
          v-if="assignmentAdding"
          :topics="currentEditingModule.topics"
          :is_required="isRequiredState"
          :is_bonus="isBonusState"
          @ASSIGNMENT_ADDED="assignmentAddedHandler"
          @ELEMENT_UPDATED="resetStates"
          @CLOSE_MODAL="resetStates"
          @CHECKBOX_STATE_CHANGE="handleCheckboxChange"
        />
      </div>
    </div>

    <div v-if="showPoints" class="points-table flex flex-col">
      <h3 class="mb-2 text-center">No. of questions</h3>
      <div v-html="getTotalPointsTable()"></div>
      <h3 class="my-2 text-center">Points</h3>
      <div class="flex justify-between border-b">
        <span class="type-name">Bonus Points</span
        ><span class="points text-right">{{ bonusPoints }}</span>
      </div>
      <div class="flex justify-between border-b">
        <span class="type-name">Total Points</span
        ><span class="points text-right">{{ totalPoints }}</span>
      </div>
    </div>
    <div class="help-section">
      <img
        src="/images/settings.svg"
        alt="settings-icon"
        class="setting-icon"
      />
      <div class="settings-and-help">
        <div class="settings-option">
          <label for="module-drag-switch">Module Draggable:</label>
          <input
            id="module-drag-switch"
            v-model="moduleDragEnable"
            type="checkbox"
            style="width: 2rem"
            @click="handleModuleDragSwitchClick($event, 'moduleDragEnable')"
          />
        </div>
        <div class="settings-option">
          <label for="topic-drag-switch">Topic Draggable:</label>
          <input
            id="topic-drag-switch"
            v-model="topicDragEnable"
            type="checkbox"
            style="width: 2rem"
            @click="handleModuleDragSwitchClick($event, 'topicDragEnable')"
          />
        </div>
        <div class="settings-option">
          <label for="question-drag-switch">Question Draggable:</label>
          <input
            id="question-drag-switch"
            v-model="questionDragEnable"
            type="checkbox"
            style="width: 2rem"
            @click="handleModuleDragSwitchClick($event, 'questionDragEnable')"
          />
        </div>
        <div class="help-container">
          <h3 class="my-4 mb-2">Help & Keyboard shortcuts</h3>
          <p class="my-2"><code>Esc</code>: Hides open modals, dropdowns</p>
          <p class="my-2">
            <code>C</code>: Add last added item (default module)
          </p>
          <p class="my-2">
            Hover over module, topic and question to get more options.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"
import ModuleCreator from "@/components/courseEditors/ModuleCreator"
import TopicCreator from "@/components/courseEditors/TopicCreator"
import QuestionStitcher from "@/components/courseEditors/QuestionStitcher"
import ModuleEditor from "@/components/courseEditors/ModuleEditor"
import TopicEdior from "@/components/courseEditors/TopicEditor"
import QuestionEditor from "@/components/courseEditors/QuestionEditor"
import AssignmentStitcher from "@/components/courseEditors/AssignmentStitcher"
import DropZone from "@/components/tree/DropZone"
import dateTimeUtils from "@/utils/dateTimeUtils"

export default {
  components: {
    VueSelect,
    ModuleCreator,
    TopicCreator,
    QuestionStitcher,
    ModuleEditor,
    TopicEdior,
    QuestionEditor,
    AssignmentStitcher,
    DropZone,
  },
  data() {
    return {
      selectedQuestionApi: undefined,
      moduleDragEnable: true,
      topicDragEnable: true,
      questionDragEnable: true,
      lastWorkedOn: "module",
      isRequiredState: true,
      isBonusState: false,
      draggedOverItemId: null,
      draggedItemObject: {},
      draggedItemType: null,
      droppedItemId: null,
      totalPoints: 0,
      bonusPoints: 0,
      showPoints: true,
      courseObject: {
        base_price: 0,
      },
      phaseOptions: [],
      phaseDetails: { name: "", description: "", index: undefined },
      megaJSON: {
        modules: [],
      },
      currentSelectedModuleID: undefined,
      currentSelectedTopicID: undefined,
      /* editing objects */
      currentEditingModule: {},
      currentEditingTopic: {},
      currentEditingQuestion: {},
      /* visibility states for creators/editors */
      moduleAdding: false,
      topicAdding: false,
      questionAdding: false,
      moduleEditing: false,
      topicEditing: false,
      questionEditing: false,
      assignmentAdding: false,
      courseName: "",
      preassessmentRequired: undefined,
      price: 0,
      /*  */
      expandedModules: [],
      expandedTopics: [],
      data: {
        course_description: "",
        why_take_this_course: "",
        course_bubbles: [],
        course_highlights: [],
        course_curriculum: [],
        course_perks: [],
      },
    }
  },
  computed: {
    getCoursePhases() {
      if (this.megaJSON.modules.length) {
        let phases = this.megaJSON.modules.filter(phase => phase.phase_id)
        phases = phases.map(phase => {
          const obj = this.phaseOptions.find(p => p.id === phase.phase_id)
          return obj
        })
        const deduplicated = [...new Set(phases)]
        // sort if all phases have index position
        if (deduplicated.every(item => item.index))
          deduplicated.sort((a, b) => a - b)
        return deduplicated
      }
      return []
    },
    currentlyEditing() {
      return (
        this.moduleAdding ||
        this.moduleEditing ||
        this.topicAdding ||
        this.topicEditing ||
        this.questionAdding ||
        this.questionEditing ||
        this.assignmentAdding
      )
    },
  },
  created() {
    this.axios({
      method: "get",
      url: `${siteConfig.siteURL}admin/courses/${this.$route.params.id}/phases`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-access-token": localStorage.token,
      },
    }).then(response => {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/courses/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        if (
          res.data.path &&
          res.data.path.phases &&
          Object.keys(res.data.path.phases).length
        ) {
          const { phases } = response.data
          phases.forEach(phase => {
            const phasePresent = res.data.path.phases[phase.id]
            if (phasePresent && phasePresent.index) {
              phase.index = parseInt(phasePresent.index)
            }
          })

          this.phaseOptions = phases
        }
        this.megaJSON = res.data.path || { modules: [] }
        this.courseName = res.data.name
        window.pageTitle = `${res.data.name}`
        this.preassessmentRequired = res.data.is_preassessment_required
        this.price = res.data.base_price
        this.data = res.data.data || {
          course_description: "",
          why_take_this_course: "",
          course_bubbles: [],
          course_highlights: [],
          course_curriculum: [],
        }
        this.data.course_perks = res.data.data.course_perks || []
        this.courseObject = res.data
      })
    })
  },
  mounted() {
    this.moduleDragEnable = JSON.parse(localStorage.moduleDragEnable || "true")
    this.topicDragEnable = JSON.parse(localStorage.topicDragEnable || "true")
    this.questionDragEnable = JSON.parse(
      localStorage.questionDragEnable || "true"
    )
    document.onkeyup = e => this.handleKeyDown(e)
    document.ondragover = e => {
      // prevent default to allow drop
      e.preventDefault()
    }
    document.ondrop = () => {
      this.draggedOverItemId = null
    }
  },
  methods: {
    handleSelectedQuestionApi(apiName) {
      this.selectedQuestionApi = apiName
    },
    handleModuleDragSwitchClick(e, item) {
      localStorage[item] = e.target.checked
    },
    handleKeyDown(e) {
      /*
      Escape Key: 27
      Letter c:   67
      */
      if (e.target.nodeName !== "INPUT" && e.target.nodeName !== "TEXTAREA") {
        // do not close the modal while editing
        if (e.which === 27 && this.currentlyEditing) {
          this.resetStates()
        } else if (
          e.which === 67 &&
          this.lastWorkedOn &&
          !this.currentlyEditing
        ) {
          // on pressing 'c' it will trigger a create modal of last worked on item
          if (this.lastWorkedOn === "module") {
            this.openModuleEditor()
          } else if (this.lastWorkedOn === "topic") {
            this.topicAdding = true
          } else if (this.lastWorkedOn === "question") {
            this.questionAdding = true
          }
        }
      }
    },
    handleCheckboxChange(data) {
      if (Object.prototype.hasOwnProperty.call(data, "is_required")) {
        this.isRequiredState = data.is_required
      } else if (Object.prototype.hasOwnProperty.call(data, "is_bonus"))
        this.isBonusState = data.is_bonus
    },
    handleDragStart(draggedItemId, type, moduleId, topicId, questionId) {
      if (
        (type === "question" && !this.questionDragEnable) ||
        (type === "topic" && !this.topicDragEnable) ||
        (type === "module" && !this.moduleDragEnable)
      ) {
        return
      }
      const data = {
        id: draggedItemId,
        type,
      }

      if (moduleId) {
        data.moduleId = moduleId
      }

      if (topicId) {
        data.topicId = topicId
      }

      if (questionId) {
        data.questionId = questionId
      }

      this.draggedItemObject = data
    },
    handleDrop(droppedOnItemId, type, moduleId, topicId) {
      this.droppedItemId = this.draggedItemObject.id
      this.shuffleListAccordingly(droppedOnItemId, type, moduleId, topicId)
      setTimeout(() => {
        this.droppedItemId = null
      }, 1000)
    },
    handleDragOver(draggedOverItemId, type) {
      if (
        type === this.draggedItemObject.type &&
        draggedOverItemId !== this.draggedItemObject.id
      ) {
        this.draggedOverItemId = draggedOverItemId
      }
    },
    shuffleListAccordingly(droppedOnItemId, type, moduleId, topicId) {
      const modules = JSON.parse(JSON.stringify(this.megaJSON.modules))

      if (type === "module") {
        const indexOfDraggedModule = modules.findIndex(
          module => module.id === this.draggedItemObject.id
        )
        const removedModule = modules.splice(indexOfDraggedModule, 1)
        const newPosition = modules.findIndex(
          module => module.id === droppedOnItemId
        )
        modules.splice(newPosition, 0, removedModule[0])
      } else if (type === "topic") {
        const currentModule = modules.find(module => module.id === moduleId)
        const indexOfDraggedTopic = currentModule.topics.findIndex(
          topic => topic.id === this.draggedItemObject.id
        )
        const removedTopic = currentModule.topics.splice(indexOfDraggedTopic, 1)
        const newPosition = currentModule.topics.findIndex(
          topic => topic.id === droppedOnItemId
        )
        currentModule.topics.splice(newPosition, 0, removedTopic[0])
      } else if (type === "question") {
        const currentModule = modules.find(module => module.id === moduleId)
        const currentTopic = currentModule.topics.find(
          topic => topic.id === topicId
        )
        const indexOfDraggedQuestion = currentTopic.questions.findIndex(
          question => question.id === this.draggedItemObject.id
        )
        const removedQuestion = currentTopic.questions.splice(
          indexOfDraggedQuestion,
          1
        )
        const newPosition = currentTopic.questions.findIndex(
          question => question.id === droppedOnItemId
        )
        currentTopic.questions.splice(newPosition, 0, removedQuestion[0])
      }
      this.draggedItemObject = {}
      this.draggedOverItemId = null
      this.megaJSON.modules = modules
    },
    getModulePhase(id) {
      const phase = this.phaseOptions.filter(p => p.id === id)
      return phase.length ? phase[0].name : ""
    },
    selectAPhase(option) {
      this.phaseDetails = option || { name: "", description: "" }
    },
    hamdlePhaseCreation() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$noty.error("Please fix the errors and try again")
          return
        }
        this.axios({
          method: "put",
          url: `${siteConfig.siteURL}admin/courses/${
            this.$route.params.id
          }/phases${this.phaseDetails.id ? `/${this.phaseDetails.id}` : ""}`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
          },
          data: {
            name: this.phaseDetails.name,
            description: this.phaseDetails.description,
          },
        })
          .then(res => {
            const phases = res.data
            phases.phase.index = parseInt(this.phaseDetails.index)
            if (!this.phaseDetails.id) {
              this.phaseOptions.push(phases.phase)
              this.$noty.success(
                `Successfully created phase - ${this.phaseDetails.name}`
              )
              return
            }

            this.phaseOptions = this.phaseOptions.map(phase => {
              if (phase.id === phases.phase.id) {
                return phases.phase
              }
              return phase
            })
            this.$noty.success(
              `Successfully updated phase - ${this.phaseDetails.name}`
            )
          })
          .catch(err =>
            this.$noty.error(
              `Something went wrong, server responed with ${err}`
            )
          )
      })
    },
    getFormatredDateTime(availableOnTime) {
      return dateTimeUtils.convertStringToComponentAcceptingFormat(
        availableOnTime
      )
    },
    updateQuestion(id, m_idx, t_idx, q_idx) {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}questions/${id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          const { name, points } = res.data.data
          this.megaJSON.modules[m_idx].topics[t_idx].questions[
            q_idx
          ].name = name
          this.megaJSON.modules[m_idx].topics[t_idx].questions[
            q_idx
          ].points = points
          this.$noty.success(`Successfully updated question - ${name}`)
        })
        .catch(() => {
          this.$noty.error(
            `Failed to update question - ${this.megaJSON.modules[m_idx].topics[t_idx].questions[q_idx].name}`
          )
        })
    },
    getPointsOfTopic(questions) {
      const table = {
        mcq: 0,
        reading: 0,
        video: 0,
        game: 0,
        code: 0,
        interview: 0,
        blockly: 0,
        web: 0,
      }
      for (let i = 0; i < questions.length; i++) {
        this.updatePointsTable(questions[i], questions[i].type, table)
      }
      return `${table.mcq ? `${table.mcq} MCQ,` : ""} ${
        table.reading ? `${table.reading} Reading,` : ""
      } ${table.video ? `${table.video} Video,` : ""} ${
        table.game ? `${table.game} Game,` : ""
      } ${table.code ? `${table.code} Code,` : ""} ${
        table.interview ? `${table.interview} Interview,` : ""
      } ${table.blockly ? `${table.blockly} Blockly,` : ""} ${
        table.web ? `${table.web} Web` : ""
      }`
    },
    getPointsOfModule(topics) {
      const table = {
        mcq: 0,
        reading: 0,
        video: 0,
        game: 0,
        code: 0,
        interview: 0,
        blockly: 0,
        web: 0,
      }
      for (let i = 0; i < topics.length; i++) {
        for (let j = 0; j < topics[i].questions.length; j++) {
          this.updatePointsTable(
            topics[i].questions[j],
            topics[i].questions[j].type,
            table
          )
        }
      }
      return `${table.mcq ? `${table.mcq} MCQ,` : ""} ${
        table.reading ? `${table.reading} Reading,` : ""
      } ${table.video ? `${table.video} Video,` : ""} ${
        table.game ? `${table.game} Game,` : ""
      } ${table.code ? `${table.code} Code,` : ""} ${
        table.interview ? `${table.interview} Interview,` : ""
      } ${table.blockly ? `${table.blockly} Blockly,` : ""} ${
        table.web ? `${table.web} Web` : ""
      }`
    },
    getTotalPointsTable() {
      const table = {
        mcq: 0,
        reading: 0,
        video: 0,
        game: 0,
        code: 0,
        interview: 0,
        blockly: 0,
        web: 0,
        required: 0,
        bonus: 0,
      }

      const { modules } = this.megaJSON
      let tempTotal = 0
      let tempBonus = 0

      // all modules
      for (let i = 0; i < modules.length; i++) {
        // single module
        for (let j = 0; j < modules[i].topics.length; j++) {
          // looping over topics
          for (let k = 0; k < modules[i].topics[j].questions.length; k++) {
            // looping over questions
            this.updatePointsTable(
              modules[i].topics[j].questions[k],
              modules[i].topics[j].questions[k].type,
              table
            )
            tempTotal += modules[i].topics[j].questions[k].points
            if (modules[i].topics[j].questions[k].is_bonus) {
              tempBonus += modules[i].topics[j].questions[k].points
            }
          }
        }
      }
      this.totalPoints = tempTotal
      this.bonusPoints = tempBonus
      let str = ""
      Object.keys(table).forEach(item => {
        str += `<div class='flex justify-between border-b'><span class='type-name'>${item}</span><span class='points text-right'> ${table[item]}</span></div>`
      })
      return str
    },
    updatePointsTable(question, type, table) {
      if (question.is_required) {
        table.required += 1
      }
      if (question.is_bonus) {
        table.bonus += 1
      }

      if (type === 0) {
        table.mcq += 1
      } else if (type === 2) {
        table.fill_blank += 1
      } else if (type === 3) {
        table.reading += 1
      } else if (type === 4) {
        table.video += 1
      } else if (type === 5) {
        table.game += 1
      } else if (type === 6) {
        table.code += 1
      } else if (type === 7) {
        table.interview += 1
      } else if (type === 8) {
        table.blockly += 1
      } else if (type === 9) {
        table.web += 1
      }
    },
    getIsDependentAssignmentTopic(module) {
      const { topics } = module

      for (let i = 0; i < topics.length; i++) {
        const assignmentIDs = module.assignment.is_dependent_ids || []
        for (let j = 0; j < assignmentIDs.length; j++) {
          if (topics[i].id === assignmentIDs[j]) {
            return topics[i].name
          }
        }
      }
      return ""
    },
    deleteAssignment(module) {
      delete module.asssignment
      const moduleCopy = JSON.parse(JSON.stringify(module))
      delete moduleCopy.assignment

      const { modules } = this.megaJSON
      for (let i = 0; i < modules.length; i++) {
        if (modules[i].id === module.id) {
          modules[i] = moduleCopy
          break
        }
      }

      this.$forceUpdate()
    },
    assignmentAddedHandler(data) {
      this.currentEditingModule.assignment = {
        name: data.assignment.name,
        id: data.assignment.id,
        is_dependent_ids: [data.is_dependent_id],
      }

      this.assignmentAdding = false
    },
    addAssignmentToModule(module) {
      this.resetStates()

      const { modules } = this.megaJSON
      for (let i = 0; i < modules.length; i++) {
        if (modules[i].id === module.id) {
          this.currentSelectedModuleID = module.id
          this.currentEditingModule = modules[i]
          this.assignmentAdding = true
          break
        }
      }
    },
    removeCoursePerk(index) {
      this.data.course_perks.splice(index, 1)
    },
    addCoursePerk() {
      this.data.course_perks.push({ text: "" })
    },
    addTopicToThisCurriculum(curriculumIndex) {
      this.data.course_curriculum[curriculumIndex].topics.push({ text: "" })
    },
    deleteTopicFromCurriculum(curriculumIndex, topicIndex) {
      this.data.course_curriculum[curriculumIndex].topics.splice(topicIndex, 1)
    },

    addCourseCurriculum() {
      this.data.course_curriculum.push({ title: "", topics: [] })
    },
    deleteCourseCurriculum(index) {
      this.data.course_curriculum.splice(index, 1)
    },
    //
    /*  */
    addCourseHighlight() {
      this.data.course_highlights.push({ description: "" })
    },
    deleteCourseHighlight(index) {
      this.data.course_highlights.splice(index, 1)
    },
    //
    /*  */
    addCourseBubble() {
      this.data.course_bubbles.push({ line_one: "", line_two: "" })
    },
    deleteCourseBubble(index) {
      this.data.course_bubbles.splice(index, 1)
    },
    deleteQuestion(questionID, idx) {
      const { modules } = this.megaJSON

      for (let i = 0; i < modules.length; i++) {
        for (let j = 0; j < modules[i].topics.length; j++) {
          const topic = modules[i].topics[j]
          for (let k = 0; k < topic.questions.length; k++) {
            if (topic.id === this.currentSelectedTopicID) {
              if (topic.questions[k].id === questionID) {
                this.megaJSON.modules[i].topics[j].questions.splice(idx, 1)
                this.resetStates()
                return
              }
            }
          }
        }
      }
    },
    deleteTopic(topicID) {
      const { modules } = this.megaJSON

      for (let i = 0; i < modules.length; i++) {
        for (let j = 0; j < modules[i].topics.length; j++) {
          const topic = modules[i].topics[j]
          if (topic.id === topicID) {
            this.megaJSON.modules[i].topics.splice(j, 1)
            this.resetStates()
            return
          }
        }
      }
    },
    deleteModule(moduleID) {
      for (let i = 0; i < this.megaJSON.modules.length; i++) {
        if (this.megaJSON.modules[i].id === moduleID) {
          this.megaJSON.modules.splice(i, 1)
          this.resetStates()
          return
        }
      }
    },
    updateModule(module) {
      this.currentEditingModule = module

      this.resetStates()
    },
    updateTopic(topic) {
      this.currentEditingTopic = topic
      this.resetStates()
    },
    isModuleExpanded(moduleID) {
      return this.checkElementExistsInArray(moduleID, this.expandedModules)
    },
    isTopicExpanded(topicID) {
      return this.checkElementExistsInArray(topicID, this.expandedTopics)
    },
    checkElementExistsInArray(elem, array) {
      for (let i = 0; i < array.length; i++) {
        if (array[i] === elem) {
          return true
        }
      }
      return false
    },
    toggleModuleExpansion(moduleID) {
      const index = this.expandedModules.indexOf(moduleID)
      if (index > -1) {
        this.expandedModules.splice(index, 1)
      } else {
        this.expandedModules.push(moduleID)
      }
    },
    toggleTopicExpansion(topicID) {
      const index = this.expandedTopics.indexOf(topicID)
      if (index > -1) {
        this.expandedTopics.splice(index, 1)
      } else {
        this.expandedTopics.push(topicID)
      }
    },
    resetStates() {
      this.moduleAdding = false
      this.topicAdding = false
      this.questionAdding = false
      this.moduleEditing = false
      this.topicEditing = false
      this.questionEditing = false
      this.assignmentAdding = false
    },
    /* Shufflers */
    shuffleUpQuestion(module, topic, question) {
      for (let i = 0; i < topic.questions.length; i++) {
        if (topic.questions[i].id === question.id) {
          if (i === 0) {
            return
          }
          const elems = [topic.questions[i - 1], topic.questions[i]]
          topic.questions.splice(i - 1, 2, elems[1], elems[0])
          break
          // topic.questions.splice(i, 2, topic.questions[i], topic.questions[i + 1]);
        }
      }
    },
    shuffleDownQuestion(module, topic, question) {
      for (let i = 0; i < topic.questions.length; i++) {
        if (topic.questions[i].id === question.id) {
          if (i === topic.questions.length - 1) {
            return
          }
          const elems = [topic.questions[i], topic.questions[i + 1]]

          topic.questions.splice(i, 2, elems[1], elems[0])
          // topic.questions.splice(i, 2, topic.questions[i], topic.questions[i + 1]);
          break
        }
      }
    },
    shuffleUpTopic(module, topic) {
      for (let i = 0; i < module.topics.length; i++) {
        if (module.topics[i].id === topic.id) {
          if (i === 0) {
            return
          }
          const elems = [module.topics[i - 1], module.topics[i]]
          module.topics.splice(i - 1, 2, elems[1], elems[0])
          break
          // topic.questions.splice(i, 2, topic.questions[i], topic.questions[i + 1]);
        }
      }
    },
    shuffleDownTopic(module, topic) {
      for (let i = 0; i < module.topics.length; i++) {
        if (module.topics[i].id === topic.id) {
          if (i === module.topics.length - 1) {
            return
          }
          const elems = [module.topics[i], module.topics[i + 1]]

          module.topics.splice(i, 2, elems[1], elems[0])
          // topic.questions.splice(i, 2, topic.questions[i], topic.questions[i + 1]);
          break
        }
      }
    },
    shuffleUpModule(module) {
      for (let i = 0; i < this.megaJSON.modules.length; i++) {
        if (this.megaJSON.modules[i].id === module.id) {
          if (i === 0) {
            return
          }
          const elems = [this.megaJSON.modules[i - 1], this.megaJSON.modules[i]]
          this.megaJSON.modules.splice(i - 1, 2, elems[1], elems[0])
          break
          // topic.questions.splice(i, 2, topic.questions[i], topic.questions[i + 1]);
        }
      }
    },
    shuffleDownModule(module) {
      for (let i = 0; i < this.megaJSON.modules.length; i++) {
        if (this.megaJSON.modules[i].id === module.id) {
          if (i === this.megaJSON.modules.length - 1) {
            return
          }
          const elems = [this.megaJSON.modules[i], this.megaJSON.modules[i + 1]]

          this.megaJSON.modules.splice(i, 2, elems[1], elems[0])
          // topic.questions.splice(i, 2, topic.questions[i], topic.questions[i + 1]);
          break
        }
      }
    },
    /* End of shufflers */

    duplicate() {
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}admin/courses/${this.$route.params.id}/duplicate`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(
        () => {
          this.$router.push(`/courses`)
        },
        error => {
          console.log(error)
        }
      )
    },
    validate() {
      const dupicateTopics = []
      const topic_count = topics =>
        topics.reduce((a, b) => ({ ...a, [b.id]: (a[b.id] || 0) + 1 }), {})

      this.megaJSON.modules.forEach(section => {
        section.topics.forEach(topic => {
          const topics_count = topic_count(topic.questions)
          let duplicates = Object.keys(topics_count).filter(
            a => topics_count[a] > 1
          )
          duplicates = duplicates.map(q =>
            topic.questions.find(a => a.id === q)
          )
          if (duplicates.length) {
            dupicateTopics.push({ name: topic.name, duplicates })
          }
        })
      })
      dupicateTopics.forEach(topic => {
        let questions = ""
        topic.duplicates.forEach(q => {
          questions += `${q.name}, `
        })
        this.$noty.error(
          `Topic - ${topic.name} has duplicate questions ${questions}`
        )
      })
      if (dupicateTopics.length) {
        return false
      }
      return true
    },
    saveData() {
      if (!this.validate()) {
        return
      }

      // get the phase id's
      // use some
      const phaseIds = []
      this.megaJSON.modules.forEach(phase => {
        if (phase.phase_id) {
          phaseIds.push(phase.phase_id)
        }
      })

      const coursePhases = {}

      if (phaseIds.length) {
        phaseIds.forEach(id => {
          coursePhases[id] = this.phaseOptions.find(phase => phase.id === id)
        })
      }

      this.courseObject.base_price = parseInt(this.price)
      this.courseObject.path = this.megaJSON
      this.courseObject.data = this.data
      this.courseObject.name = this.courseName
      this.courseObject.is_preassessment_required = this.preassessmentRequired

      const phaseKeys = Object.keys(coursePhases)
      if (phaseKeys.length) {
        // do not allow save if index isn't present for all phases isn't added
        for (let i = 0; i < phaseKeys.length; i++) {
          if (
            !Object.prototype.hasOwnProperty.call(
              coursePhases[phaseKeys[i]],
              "index"
            ) ||
            typeof coursePhases[phaseKeys[i]].index !== "number"
          ) {
            this.$noty.error(
              `Index posision isn't added to phase: ${coursePhases[phaseKeys[i]].name}`
            )
            return
          }
        }
        this.courseObject.path.phases = coursePhases
      }

      const dataloader = this.$loading.show()
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}admin/courses/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: this.courseObject,
      })
        .then(res => {
          // Store new data in api server if msg server call with the new slug
          this.courseObject = res.data
          this.updateMongo()
          dataloader.hide()
        })
        .catch(() => {
          dataloader.hide()
        })
    },
    updateMongo() {
      const dataloader = this.$loading.show()
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}forum/concept`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: JSON.stringify({
          course_slug: this.courseObject.slug,
          path: this.courseObject.path,
          bulk: true,
        }),
      })
        .then(() => {
          dataloader.hide()
          window.alert("Successfully updated concept keys")
        })
        .catch(() => {
          dataloader.hide()
          window.alert("Failed to update concept keys")
        })
    },
    iconToDisplay(type) {
      //       [
      //     "MCQ",
      //     "IMCQ", // not in use
      //     "FILL_BLAK",
      //     "READING",
      //     "VIDEO",
      //     "GAME",
      //     "CODE",
      //     "INTERVIEW",
      //     "BLOCKLY",
      //     "WEB",
      // ]

      let iconName = "close" // default unknown icon
      if (type === 0) {
        // MCQ
        iconName = "question_answer"
      } else if (type === 1) {
        iconName = "block"
      } else if (type === 2) {
        iconName = "block"
      } else if (type === 3) {
        iconName = "insert_drive_file"
      } else if (type === 4) {
        iconName = "video_library"
      } else if (type === 5) {
        iconName = "games"
      } else if (type === 6) {
        iconName = "code"
      } else if (type === 7) {
        iconName = "camera_alt"
      } else if (type === 8) {
        iconName = "casino"
      } else if (type === 9) {
        iconName = "web"
      }
      return iconName
    },
    openModuleEditor() {
      this.moduleAdding = true
      this.topicAdding = false
      this.questionAdding = false
      this.moduleEditing = false
      this.topicEditing = false
      this.questionEditing = false
      this.lastWorkedOn = "module"
    },
    addModule(moduleData, is_dependent_ids, phaseId) {
      this.megaJSON.modules.push({
        id: moduleData.id,
        name: moduleData.name,
        slug: moduleData.slug,
        is_required: moduleData.is_required,
        is_bonus: moduleData.is_bonus,
        is_payment_locked: moduleData.is_payment_locked,
        is_dependent_ids,
        phase_id: phaseId || "",
        topics: [],
      })
      this.resetStates()
    },
    addTopic(topicData, is_dependent_ids) {
      const topicObj = {
        id: topicData.id,
        name: topicData.name,
        slug: topicData.slug,
        is_required: topicData.is_required,
        is_bonus: topicData.is_bonus,
        is_dependent_ids,

        questions: [],
      }
      if (topicData.available_on) {
        topicObj.available_on = topicData.available_on
      }
      const { modules } = this.megaJSON
      for (let i = 0; i < modules.length; i++) {
        if (modules[i].id === this.currentSelectedModuleID) {
          modules[i].topics.push(topicObj)
        }
      }
      this.resetStates()
    },
    addQuestion(obj) {
      const { modules } = this.megaJSON
      for (let i = 0; i < modules.length; i++) {
        if (modules[i].id === this.currentSelectedModuleID) {
          const { topics } = modules[i]
          for (let j = 0; j < topics.length; j++) {
            if (topics[j].id === this.currentSelectedTopicID) {
              /*  */

              const questionObj = obj.questionObject
              questionObj.is_required = obj.is_required
              questionObj.slug = obj.questionObject.slug
              questionObj.points = obj.questionObject.points || 0
              questionObj.is_bonus = obj.is_bonus

              delete questionObj.list
              topics[j].questions.push(questionObj)
            }
          }
        }
      }
      this.resetStates()
    },
    editQuestion(module, topic, question, idx) {
      this.resetStates()
      this.questionEditing = true

      this.currentSelectedModuleID = module.id
      this.currentSelectedTopicID = topic.id
      this.currentEditingQuestion = question
      this.currentEditingQuestion.idx = idx
    },
    editModule(module) {
      this.resetStates()
      this.moduleEditing = true

      this.currentSelectedModuleID = module.id

      this.currentEditingModule = module
    },
    editTopic(module, topic) {
      this.resetStates()
      this.topicEditing = true

      this.currentEditingModule = module
      this.currentEditingTopic = topic
      this.currentSelectedModuleID = module.id
      this.currentSelectedTopicID = topic.id
    },
    addQuestionToTopic(module, topic) {
      this.resetStates()
      this.questionAdding = true

      this.currentEditingTopic = topic
      this.currentEditingModule = module
      /*  */
      this.currentSelectedModuleID = module.id
      this.currentSelectedTopicID = topic.id
      this.lastWorkedOn = "question"
    },
    addTopicToModule(module) {
      this.resetStates()
      this.topicAdding = true

      this.currentEditingModule = module
      this.currentSelectedModuleID = module.id
      this.lastWorkedOn = "topic"
    },
    //
    getRequiredAndBonusTopics(module) {
      const { topics } = module
      let is_required = 0
      let is_bonus = 0
      const { length } = topics

      for (let i = 0; i < topics.length; i++) {
        if (topics[i].is_required) {
          is_required++
        }
        if (topics[i].is_bonus) {
          is_bonus++
        }
      }
      return `${length} topics (${is_required} required, ${is_bonus} bonus)`
    },
    getRequiredAndBonusQuestions(topic) {
      const { questions } = topic
      let is_required = 0
      let is_bonus = 0
      const { length } = questions

      for (let i = 0; i < questions.length; i++) {
        if (questions[i].is_required) {
          is_required++
        }
        if (questions[i].is_bonus) {
          is_bonus++
        }
      }
      return `${length} questions (${is_required} required, ${is_bonus} bonus)`
    },
    //
    getIsDependentModules(module) {
      const ids = module.is_dependent_ids
      const names = []
      for (let i = 0; i < this.megaJSON.modules.length; i++) {
        for (let j = 0; j < ids.length; j++) {
          if (this.megaJSON.modules[i].id === ids[j]) {
            names.push(this.megaJSON.modules[i].name)
          }
        }
      }
      return names.join(", ")
    },
    getIsDependentTopics(module, topic) {
      const { topics } = module
      const ids = topic.is_dependent_ids
      const names = []
      for (let i = 0; i < topics.length; i++) {
        for (let j = 0; j < ids.length; j++) {
          if (topics[i].id === ids[j]) {
            names.push(topics[i].name)
          }
        }
      }
      return names.join(", ")
    },
  },
}
</script>

<style scoped>
.settings-and-help {
  display: none;
  position: relative;
  top: 0;
  right: 0;
  margin-top: 2rem;
}
.help-section:hover .settings-and-help {
  display: block;
}

.help-section:hover {
  background: white;
  box-shadow: 0 0 6px 0 #6d6d6d;
}

.settings-option {
  display: flex;
  width: 60%;
  justify-content: space-between;
}
.settings-option input[type="checkbox"] {
  width: 2rem;
}
.settings-option input[type="checkbox"]::after,
.settings-option input[type="checkbox"]::before {
  display: none;
}
.help-section {
  position: fixed;
  top: 2rem;
  right: 13rem;
  width: 20rem;
  height: auto;
  padding: 1rem;
  border-radius: 3px;
}

.help-container {
  font-size: 0.9rem;
}

.help-container code {
  padding: 0 5px;
  border-radius: 3px;
  background: #d1d1d1;
}

.setting-icon {
  position: absolute;
  right: 1rem;
  width: 2rem;
  height: 2rem;
}
.btns-container {
  visibility: hidden;
  position: absolute;
  top: 0;
  right: 0;
  background: #f1f1f1;
}

.tree-question-container:hover .btns-container,
.tree-module-container:hover .btns-container,
.tree-topic-container:hover .btns-container {
  visibility: visible;
}
.animate-drop {
  transition: all 0.3s ease-out;
  animation: fadeOutBackground 1s ease-out;
}

@keyframes fadeOutBackground {
  0% {
    background-color: #d4d4d4;
    box-shadow: 0 0 3px 1px #919191;
  }
  100% {
    background-color: white;
    box-shadow: none;
  }
}

.tree-table {
  width: 50%;
}
.points-table {
  position: fixed;
  top: 10px;
  right: 20px;
  width: 150px;
  font-size: 0.9rem;
}

.addition-card {
  position: fixed;
  z-index: 200;
  top: 20px;
  right: 11rem;
  width: 520px;
  box-shadow: 0 0px 5px 0 #151515;
}

.points-table > div {
  padding: 2px;
  text-align: left;
}
.points-table > div > span {
  display: inline-block;
  width: 50%;
  text-align: left;
}
.points-table > div > .points {
  text-align: right;
}

.dragged-item {
  background: #f1f1f1;
}
</style>

<style lang="postcss">
.edit-button-tree {
  padding-left: 8px;
  color: red;
  cursor: pointer;
}
.edit-button-tree:hover {
  color: #e00000;
}
.element-highlight-container {
  display: block;
  margin-top: 4px;
  margin-left: 36px;
  padding: 4px;
  border: 1px solid #5f9ea0;
  color: #000;
  background-color: rgba(0, 255, 0, 0.2);
  font-size: 0.8em;
}
.module-add-container {
  margin-top: 50px;
}
.tree-question-container {
  margin: 15px;
  margin-left: 30px;
  cursor: default;
}

.tree-question-container:hover {
  background: #e0e0e086;
}
.tree-module-container {
  margin: 15px;
  margin-left: 0;
  cursor: default;
}

.module-points-table,
.topic-points-table {
  position: absolute;
  top: 15px;
  right: -350px;
}

.topic-points-table {
  right: -380px;
}

.tree-topic-container {
  margin: 15px;
  margin-left: 30px;
  cursor: default;
}

.tree-topic-container[draggable="true"] {
  cursor: pointer;
}

.tree-question-container[draggable="true"] {
  cursor: grab;
}
.tree-module-container[draggable="true"] {
  cursor: grab;
}

.tree-icon {
  position: relative;
  z-index: 10;
  top: 6px;
  color: #272626;
  cursor: pointer;
}

.hover-tree-info {
  display: none;
  position: absolute;
  z-index: 100;
  top: -20px;
  left: 10px;
  padding: 4px;
  border: 1px solid black;
  color: black;
  background-color: white;
  font-size: 0.7em;
  pointer-events: none;
}
.bonus-tree-icon:hover > .hover-tree-info {
  display: inline;
}
.required-tree-icon:hover > .hover-tree-info {
  display: inline;
}
.required-tree-icon {
  position: relative;
  top: 6px;
  color: blue;
}
.bonus-tree-icon {
  position: relative;
  top: 6px;
  color: yellow;
}
.meta-info-for-elements {
  display: inline-block;
  margin-top: 4px;
  margin-left: 36px;
  padding: 4px;
  border: 1px solid cadetblue;
  color: black;
  background-color: rgba(0, 255, 0, 0.2);
  font-size: 0.8em;
}
.arrows-container {
  padding-left: 20px;
}
.arrow-icon-ordering {
  padding: 3px 10px;
  font-size: 1em;
  cursor: pointer;
}
.arrow-icon-ordering:hover,
.edit-button-tree:hover {
  background-color: lightgrey;
}
.edit-button {
  padding-left: 10px;
  color: red;
  cursor: pointer;
}
.add-icon {
  color: green !important;
}
.add-module-container {
  display: inline-block;
  width: 200px;
  padding: 4px 0px;
  border: 1px solid black;
}
.tree-icon {
  position: relative;
  z-index: 10;
  top: 6px;
  color: #272626;
}
.tree-container {
  position: relative;
  width: 100%;
  padding: 10px;
  cursor: pointer;
}
.module-folder-container-new-post {
  margin-bottom: 10px;
}
.module-folder-name {
  display: inline;
  position: relative;
  padding-left: 10px;
  transition: all 0.1s;
}
.topic-folder-container-new-post {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 200px;
  margin-top: 1px;
  margin-left: 44px;
  padding-bottom: 10px;
  padding-left: 10px;
  background-color: #e6e3e3;
}
.module-root-folder {
  display: inline;
  position: relative;
  padding-left: 10px;
  transition: all 0.1s;
}
.module-root-folder-create {
  display: block;
  position: relative;
  padding-left: 10px;
  transition: all 0.1s;
}
.module-folder-name:hover {
  color: black;
}
.topic-folder-container {
  margin-top: 10px;
  margin-left: 40px;
}
.post-folder-container {
  margin-top: 1px;
  margin-left: 40px;
  padding: 10px;
}
.post-folder-container-new-post {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 200px;
  margin-top: 1px;
  margin-left: 44px;
  padding-bottom: 10px;
  padding-left: 10px;
  background-color: #e6e3e3;
}
.tree-collapsor {
  display: inline-block;
  width: 40px;
  padding-left: 10px;
  color: #949494;
  font-size: 1.2em;
  font-weight: 700;
  user-select: none;
}
.add-icon-module {
  color: #73b114;
}
.curriculum-topic-container {
  float: right;
  width: 90%;
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #bbbbbb;
  background-color: #f3f3f3;
}
.img-responsive {
  display: block;
  width: 90%;
  height: auto;
  margin: auto;
  margin-top: 30px;
  margin-bottom: 10px;
}
.course-description-textarea {
  width: 90%;
  min-height: 200px;
  margin: auto;
}
.course-data-details {
  width: 90%;
  margin: auto;
  margin-top: 355px;
  padding: 10px;
  border: 1px solid grey;
  background-color: #ece8e8;
}
.course-info-type {
  padding: 4px 4px;
  border: 1px solid #c1bcbc;
  background-color: #ece8e8;
}
.course-id-span {
  color: #e46262;
  font-size: 16px;
}
.assignment-container {
  margin-left: 50px;
  padding: 14px;
  border: 1px solid #18a0dc;
  background-color: #9ee1ff;
}

.phase-wrapper {
  @apply shadow-md p-4 mb-5 pt-8;
  width: 100%;
  height: auto;
}
.phases-container textarea {
  width: 90%;
  height: auto;
  min-height: 100px;
  border: 1px solid #cccccc;
}
</style>
<!-- global styles for child components -->
<style>
.close-button {
  z-index: 1;
  top: 10px;
  right: 10px;
  padding: 5px;
}

.close-button:hover {
  background: lightgrey;
}
</style>
